import { render, staticRenderFns } from "./measureCategory.vue?vue&type=template&id=37565b71"
import script from "./measureCategory.vue?vue&type=script&lang=js"
export * from "./measureCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports